export default {
  SET_SITES: function (state, sites) {
    state.sites = sites;
  }
}
